module.exports = __webpack_public_path__ + "img/cave66.308696b5.jpg";